import { render, staticRenderFns } from "./brandFilterList.vue?vue&type=template&id=2460185f&scoped=true"
import script from "./brandFilterList.vue?vue&type=script&lang=js"
export * from "./brandFilterList.vue?vue&type=script&lang=js"
import style0 from "./brandFilterList.vue?vue&type=style&index=0&id=2460185f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2460185f",
  null
  
)

export default component.exports